export const SET_ACCOUNTLESS_APP_ENTRY = 'SET_ACCOUNTLESS_APP_ENTRY';

export const setAccountlessAppEntry = (isEnabled: boolean) => ({
	type: SET_ACCOUNTLESS_APP_ENTRY,
	isEnabled,
});
